import Footer from '../Components/Footer/Footer'
import ScrollToTop from '../Components/ScrollToTop'
import HeroSection8 from '../Components/HeroSection8/index8'
import Card_con from '../Components/Card_con/Card'
import InfoSection7 from '../Components/Infosection7/Index7'
import { homeObjOne7 } from '../Components/Infosection7/Data7'

const Consultant = () => {
  return (
    <>
        <ScrollToTop />
        <HeroSection8 />
        <Card_con />
        <InfoSection7 {...homeObjOne7} />
        <Footer />
    </>
  )
}

export default Consultant